import React from 'react';
import { Box, CircularProgress, CircularProgressProps } from '@mui/material';
import { styled } from '@mui/material';

const Loader = styled(CircularProgress)(({ theme }) => ({
	color: theme.palette?.theme.primary[500]
}));

const LoaderContainer = styled(Box)(() => ({
	position: 'fixed',
	display: 'flex',
	width: '100%',
	height: '100%',
	justifyContent: 'center',
	alignItems: 'center',
	backgroundColor: '#ffffff96',
	zIndex: 1,
	left: 0,
	top: 0
}));

const FormLoader = (props: CircularProgressProps) => {
	return (
		<LoaderContainer>
			<Loader size={50} {...props} />
		</LoaderContainer>
	);
};

export { FormLoader };
export default FormLoader;
